export default __webpack_public_path__ + "static/media/RDM_02.88d9e630.png";